























import {Component, Vue} from "vue-property-decorator";
import Inputfield from "@/components/partials/Inputfield.vue";
import TDSSpinner from "@/components/common/TDSSpinner.vue";
import TDSButton from "../common/TDSButton.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import { Invitation } from "@/interfaces/entities/Invitation";

interface ShareTokenData {
    sub: string;
    exp: number;
}

@Component({
    components: {
        TDSSpinner,
        Inputfield,
        DefaultLayout,
        TDSButton
    }
})
export default class InvitationPage extends Vue {
    private showInfo: boolean = false;
    private accepted: boolean = false;
    private invitation: Invitation = { companyName: "", status: "" };

    get isMobile(): boolean {
        return this.$store.state.isMobile;
    }

    created() {
        this.fetchCustomerData();
    }

    private async acceptInvite() {
        const token = this.$route.query.token ?? "";
        try {
            await this.$store.dispatch("ACCEPT_INVITATION", token);
            this.accepted = true;
        }catch (e) {
            this.$toastr.error( this.$t("invitation.error.accept") ).then(() =>location.reload());
        }
    }

    private async fetchCustomerData() {
        const token = this.$route.query.token ?? "";
        if (!this.isValidShareToken(token)) {
            this.$toastr.error(this.$t("esimInstallation.error.tokenInvalid")).then(() =>location.reload());
        } else {
            try {
                this.invitation = await this.$store.dispatch("FETCH_INVITATION", token);
                console.log("[InvitationPage] Fetched invitation data: ", this.invitation);
                this.accepted = this.invitation.status.toLowerCase() === "accepted";
                this.showInfo = true;
            }catch (e) {
                this.$toastr.error(this.$t("invitation.error.fetch"), e.response.data.detail).then(() =>location.reload());
            }
        }
    }

    private isValidShareToken(token: string | (string | null)[]): boolean {
        if (Array.isArray(token)) throw new Error("Token query param is not a string!");
        if (!token) return false;
        try {
            const {sub: iccid, exp: expiresAt}: ShareTokenData = JSON
                .parse(atob(token.split(".")[1]));
            if (Date.now() > expiresAt * 1000) {
                console.log("[InvitationPage] Share token is expired!");
                return false;
            }
            console.log(`[InvitationPage] Data from token:\n\tuuid='${iccid}'\n\texpiresAt='${new Date(expiresAt * 1000)}'`);
            return true;
        } catch (e) {
            console.log("[InvitationPage] Error on parsing token: ", e);
            return false;
        }
    }
}
